import { IResource } from 'capability-ng-resources';
import * as _4 from 'lodash4';
import { PathTask } from '../../data/builders/path_task_builder';
import { ITipDetail, ITipDetailRoot } from './../../todo_interface';
import { ILocationGroup } from './../my_path_task_detail_child/my_path_task_detail_child_controller';

interface ITipDetailModel {
  item: ITipDetailRoot;
  task: PathTask;
  resources: IResource[];
  locationGroups: ILocationGroup[];
}

interface ITipDetailFlag {
  hasResources: boolean;
  hasChildren: boolean;
}

export class TipDetailsController {
  private models: ITipDetailModel;
  private flags: ITipDetailFlag;
  private tipDetail: ITipDetail;

  $onInit() {
    this.models = {
      item: this.tipDetail.root,
      task: this.tipDetail.source.task,
      resources: this.tipDetail.resource,
      locationGroups: this.tipDetail.source.locationGroups
    };

    this.flags = {
      hasResources: !_4.isEmpty(this.models.resources),
      hasChildren: !_4.isEmpty(this.tipDetail.root.children)
    };
  }
}
export class TipDetailsComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/tip_details/tip_details.html';
  public controller: any = TipDetailsController;
  public bindings: any = {
    tipDetail: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/tip_details/tip_details_controller.ts